<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Presentation Themes Management <span class="badge badge-primary">{{
              count
            }}</span>
          </h5>
        </div>
        <div class="col-md-8 col-xs-12 align-self-center">
          <nav aria-label="breadcrumb" class="mt-2 float-md-right float-left">
            <ol class="breadcrumb mb-0 justify-content-end p-0">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li aria-current="page" class="breadcrumb-item active">Presentation Themes Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-6">
                  <label for="slug">Search by theme name</label>
                  <div class="input-group">
                  <span class="input-group-btn">
                    <button class="btn waves-effect waves-light btn-info" type="button">
                      <i class="fa fa-search"></i>
                    </button>
                  </span>
                    <input
                        v-model="textSearch"
                        class="form-control"
                        placeholder="Search by theme name"
                        type="text"
                        @change="searchPresentation()"
                    />
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="slug">Official Themes</label>
                  <div class="input-group">
                    <select v-model="filters.isOfficial" class="form-control" @change="filter()">
                      <option value="">All</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="table-responsive">
                  <div class="text-center">
                    <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-category">
                    <thead>
                    <tr>
                      <th @click="sortByField('id')">
                        ID
                        <span v-if="sortBy ==='id'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('themeName')">
                        Name
                        <span v-if="sortBy ==='themeName'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th>
                        Created By
                      </th>
                      <th @click="sortByField('createdAt')">
                        Created at
                        <span v-if="sortBy ==='createdAt'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('updatedAt')">
                        Updated at
                        <span v-if="sortBy ==='updatedAt'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('isOfficial')">
                        Publish as an Official Theme
                        <span v-if="sortBy ==='isOfficial'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                      <td>{{ item.id }}</td>
                      <td>{{ item.themeName }}</td>
                      <td>{{ item.user.email }}</td>
                      <td>{{ item.createdAt | dateTime }}</td>
                      <td>{{ item.updatedAt | dateTime }}</td>
                      <td>
                        <input v-model="item.isOfficial" name="isOfficial" type="checkbox"
                               @click.stop="patchPresentationThemes('isOfficial', item, index)">
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <div v-if="!isLoading" class="overflow-auto">
                    <b-pagination v-model="page" :per-page="limit" :total-rows="count"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config"

export default {
  name: "TemplatesCategories",
  data() {
    return {
      items: [],
      page: 1,
      limit: 30,
      count: 0,
      isLoading: false,
      sortDesc: true,
      sortBy: "id",
      textSearch: "",
      filters: {
        active: '',
        onlyPresenter: ''
      },
      errPropertyMapping: {},
      msgError: '',
      dataCategory: {},
      idOpenDetailCategory: null,
      isCreatingCategory: false,
    }
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  watch: {
    page: {
      handler: function () {
        this.getData()
      },
      deep: true
    }
  },
  methods: {
    searchPresentation() {
      this.getData()
    },
    filter() {
      this.getData()
    },
    sortByField(field) {
      this.sortBy = field
      this.sortDesc = !this.sortDesc

      this.getData()
    },
    getFilterData() {
      const filters = {}
      Object.keys(this.filters).forEach((keyFilter) => {
        if (this.filters[keyFilter] !== '') {
          filters[keyFilter] = this.filters[keyFilter]
        }
      })
      return filters
    },
    async getData() {
      this.isLoading = true
      let params = {
        page: this.page,
        limit: this.limit,
        filters: this.getFilterData(),
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      if (this.textSearch) {
        params.textSearch = this.textSearch
      }
      const res = await this.callApiGetData(params)
      this.isLoading = false
      if (!res) {
        return false
      }
      const results = res.body
      this.items = results.data
      this.count = results.total
    },
    async callApiGetData(params) {
      try {
        return await this.$http
            .get(Config.api.getThemes, {
              params: params
            });
      } catch (e) {
        console.log(e)
        return false
      }
    },
    async callApiUpdatePresentationThemes(id, payload) {
      try {
        return await this.$http
            .patch(`${Config.api.updatePresentationThemes(id)}`, payload)
      } catch (e) {
        console.log(e)
        return false
      }
    },
    async patchPresentationThemes(property, item, index) {
      const payload = {}
      payload[property] = !item[property]
      const res = await this.callApiUpdatePresentationThemes(item.id, payload)
      if (!res) {
        this.$toasted.error('Update presentation themes error!', {duration: 10000})
        this.items[index][property] = !payload[property]
        return false
      }
      this.$toasted.success('Update presentation themes success!', {duration: 500})
      return true
    },
  }
}
</script>
<style lang="scss" scoped>
.addUser-btn {
  background-color: #4f9af2;
  border-radius: 20px;
  border-color: #4f9af2;

  &:hover {
    background-color: #2785f0;
    border-color: #2785f0;
  }
}

.table-category {
  th {
    &:hover {
      cursor: pointer;
    }
  }
}

.form-create-category {
  .error {
    .msg-error {
      display: block;
      font-size: 0.75rem;
      color: #ff5050;
      padding-top: 5px;
    }
  }

  .msg-error {
    display: none;
  }
}

.btn-add-category {
  width: 100%;
}
</style>
